import * as signalR from "@microsoft/signalr";

export function createSignalRConnection(accessToken?: string) {
  return new signalR.HubConnectionBuilder()
    .withUrl(`${process.env.REACT_APP_API_URL}/hub/notifications`, {
      accessTokenFactory: () => accessToken ?? "",
    })
    .withAutomaticReconnect({
      nextRetryDelayInMilliseconds: (retryContext) => {
        if (retryContext.previousRetryCount < 3) return 1000;
        if (retryContext.previousRetryCount < 6) return 3000;
        return 5000;
      },
    })
    .configureLogging(signalR.LogLevel.Warning)
    .build();
}
